import { useEffect, useRef, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { log } from "@/lib/log";

const REDIRECT_DELAY_MS = 1200;
const POLL_INTERVAL_MS = 2000;
const MAX_POLLS = 10;

export default function PaymentSuccess() {
  const [params] = useSearchParams();
  const nav = useNavigate();
  const { reload } = useAuth();
  const [state, setState] = useState("checking");
  const started = useRef(false);
  useEffect(() => {
    if (started.current) return;
    started.current = true;
    const sid = params.get("session_id");
    if (!sid) { setState("error"); return; }
    let tries = 0;
    const tick = async () => {
      try {
        const { data } = await api.get(`/payments/status/${sid}`);
        if (data.payment_status === "paid") { setState("paid"); await reload(); setTimeout(() => nav("/billing?welcome=1"), REDIRECT_DELAY_MS); return; }
        if (["expired", "failed"].includes(data.payment_status)) { setState("error"); return; }
      } catch (e) {
        log.warn("Payment status check failed, retrying:", e?.response?.status || e?.message);
      }
      if (++tries < MAX_POLLS) setTimeout(tick, POLL_INTERVAL_MS); else setState("timeout");
    };
    tick();
  }, [params, nav, reload]);
  return (
    <div className="min-h-screen flex items-center justify-center bg-[#0b0f17] text-slate-200 font-mono text-sm" data-testid="payment-success-page">
      {state === "checking" && <div className="animate-pulse">Confirming your payment with Stripe…</div>}
      {state === "paid" && <div className="text-emerald-400" data-testid="payment-confirmed">Payment confirmed — activating your plan…</div>}
      {state === "timeout" && <div>Payment is still processing. Check the <button onClick={() => nav("/billing")} className="text-amber-400 underline">Billing page</button> in a minute.</div>}
      {state === "error" && <div className="text-red-400">Payment was not completed. <button onClick={() => nav("/billing")} className="text-amber-400 underline">Back to Billing</button></div>}
    </div>
  );
}
